// --- CONTROL DE CACHE --- //
const LS_KEY = "one_tribe_stats";
const API_URL = "https://abilityhire-automation.onrender.com/one-tribe";

// Renderiza inmediatamente desde LocalStorage si existe
function renderFromLocal() {
  const container = document.getElementById("one-tribe-stats-dynamic");
  const stats = JSON.parse(localStorage.getItem(LS_KEY));

  if (!container || !stats) return;

  container.innerHTML = generateCardsHTML(stats);
}

// Genera el HTML idéntico a las primeras cards
function generateCardsHTML(stats) {
  return `
    <div class="one-tribe-grid">
      ${card("🌲", stats.trees, "Trees Protected")}
      ${card("🚛", stats.co2, "Tonnes Carbon Stored")}
      ${card("🌾", stats.acres, "Acres Saved")}
      ${card("🚗", stats.cars, "Car Emissions Removed")}
      ${card("♻️", stats.carbonSequestered, "Carbon Sequestered (T)")}
      ${card("👥", stats.communitiesSupported, "Communities Supported")}
      ${card("📁", stats.projectsFunded, "Projects Funded")}
      ${card("🌐", stats.UNSDGsAchieved, "UN SDGs Achieved")}
    </div>
  `;
}


// Componente tarjeta con estética original
function card(emoji, value, label) {
  return `
    <div class="text-with-icon-item--inner column-border-enabled column-shadow-enabled icon-position-top text-left">
          <div class="text-with-icon--icon icon-gap-medium icon-no-style large-icon">
            <span style="font-size:42px">${emoji}</span>
          </div>
          <div class="text-with-icon--content pos-relative">
            <h6 class="text-with-icon--heading h6">${value ?? "-"}</h6>
            <p class="text-with-icon--desc text-medium">${label}</p>
          </div>
        </div>
  `;
}


// --- FETCH DESPUÉS QUE CARGA LA PÁGINA --- //
async function updateStats() {
  try {
    const res = await fetch(API_URL);
    const data = await res.json();

    const stats = data; // NO hay .stats
    if (!stats) return;

    // Guardar en cache
    localStorage.setItem(LS_KEY, JSON.stringify(stats));

    // Renderizar visual
    renderFromLocal();

    console.log("🔥 OneTribe actualizado:", stats);

  } catch (e) {
    console.error("❌ Error cargando OneTribe:", e);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  console.log("⚡ Cargando OneTribe desde cache...");
  renderFromLocal();

  // Actualizar en segundo plano
  setTimeout(updateStats, 1000);
});
